import React from 'react';
var ThemeContext = React.createContext(null);
export var ThemeProvider = ThemeContext.Provider;
export var ThemeConsumer = ThemeContext.Consumer;
export default ThemeContext;
//# sourceMappingURL=theme-context.js.map